import React from 'react'
import { NAV } from 'Config/Routing/nav'
import { PATHS } from 'Config/Routing/paths'
import { PageNav, PageNavItem } from 'Components/PageNav'
import { authorization as auth } from './../../../../Module/Auth/Auth'

const CityHeaderNavUnstyled = ({ history, cityId }) => {
  const BASE_URL =
    PATHS.main.dashboard + PATHS.dashboard.cities + '/' + cityId + '/'

  return (
    <PageNav history={history}>
      {/* NOTE SPY is considered a CM by existing logic and it's pretty baked in hence the extra condition*/}
      {(auth.isAdmin() || auth.isCityManager()) && !auth.isSpy() ? (
        <PageNavItem
          href={BASE_URL + NAV.CITY_HEADER_NAV.LOCATIONS + '/handtohand'}
        >
          Locations
        </PageNavItem>
      ) : null}
      <PageNavItem href={BASE_URL + NAV.CITY_HEADER_NAV.MASTER_SCHEDULE}>
        Global Planning
      </PageNavItem>
      {(auth.isAdmin() || auth.isCityManager()) && !auth.isSpy() ? (
        <PageNavItem href={BASE_URL + NAV.CITY_HEADER_NAV.LIVE_MAP}>
          Live Map
        </PageNavItem>
      ) : null}
      {(auth.isAdmin() || auth.isCityManager()) && !auth.isSpy() ? (
        <PageNavItem href={BASE_URL + NAV.CITY_HEADER_NAV.AMBASSADORS}>
          Brand Ambassadors
        </PageNavItem>
      ) : null}
      {(auth.isAdmin() || auth.isCityManager()) && !auth.isSpy() ? (
        <PageNavItem href={BASE_URL + NAV.CITY_HEADER_NAV.INVENTORY}>
          Inventory
        </PageNavItem>
      ) : null}
      {(auth.isAdmin() || auth.isCityManager()) && !auth.isSpy() ? (
        <PageNavItem href={BASE_URL + NAV.CITY_HEADER_NAV.PICKUP}>
          Pickup
        </PageNavItem>
      ) : null}
      {auth.isSpy() || (
        <PageNavItem href={BASE_URL + NAV.CITY_HEADER_NAV.STATS}>
          Stats
        </PageNavItem>
      )}
      {(auth.isAdmin() || auth.isCityManager()) && !auth.isSpy() ? (
        <PageNavItem href={BASE_URL + NAV.CITY_HEADER_NAV.SPY}>Spy</PageNavItem>
      ) : null}
    </PageNav>
  )
}

export { CityHeaderNavUnstyled }



// WEBPACK FOOTER //
// ./src/Containers/City/Page/HeaderNav/unstyled.js